import React from "react";
import { withStyles } from "@material-ui/core/styles";
import { withRouter } from "react-router-dom";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import ArrowBack from "@material-ui/icons/ArrowBack";
import Typography from "@material-ui/core/Typography";
import logo from "../../img/logo/logo_light.svg";
import indigo from "@material-ui/core/colors/indigo";
import ReportTestForm from "./components/Forms/ReportTestForm";
import { informProblem } from "../../redux/actions/sagaActions";
import { connect } from "react-redux";

const styles = theme => ({
  root: {
    flexGrow: 1
  },
  container: {
    padding: 25
  },
  containerTop: {
    paddingTop: 0,
    marginTop: -15
  },
  menuButton: {
    marginLeft: -12,
    marginRight: 0
  },
  center: {
    textAlign: "center"
  },
  title: {
    color: "#000",
    fontWeight: 500
  },
  enviar: {
    background: indigo["A400"],
    color: "white"
  }
});

class ReportTest extends React.PureComponent {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleBackButton = () => {
    this.props.history.goBack();
  };

  handleSubmit(val) {
    // Do anything you want with the form value
    console.debug(val);
    let {
      informProblem,
      match: {
        params: { project }
      },
      vc_profile,
      history
    } = this.props;
    informProblem({ data: { ...val, project, vc_profile } });
    history.push("/account/home?at=1");
  }

  render() {
    const {
      classes,
      match: {
        params: { id }
      }
    } = this.props;

    return (
      <div style={{ marginTop: "64px" }}>
        <AppBar
          position="static"
          style={{ background: "transparent", boxShadow: "none" }}
        >
          <Toolbar>
            <IconButton
              className={classes.menuButton}
              onClick={this.handleBackButton}
              style={{ color: "#000" }}
            >
              <ArrowBack />
            </IconButton>
          </Toolbar>
        </AppBar>
        <div className={classes.containerTop}>
          <Grid container>
            <Grid item xs={12} className={classes.center}>
              <img src={logo} style={{ maxHeight: 32 }} />
            </Grid>
          </Grid>
        </div>
        <div className={classes.container} style={{ paddingTop: 25 }}>
          <Grid container>
            <Grid item xs={12} className={classes.center}>
              <Typography variant="display1" className={classes.title}>
                Informar de un problema
              </Typography>
            </Grid>
          </Grid>
        </div>
        <div className={classes.container} style={{ paddingTop: 0 }}>
          <ReportTestForm onSubmit={this.handleSubmit} />
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  vc_profile: state.auth.user_id || -1
});

export default withRouter(
  withStyles(styles, { withTheme: true })(
    connect(
      mapStateToProps,
      { informProblem }
    )(ReportTest)
  )
);



// WEBPACK FOOTER //
// ./src/modules/test/ReportTest.js